import Email from "@/domain/entities/emails/Email";
import TodoItem from "@/domain/entities/TodoItem";
import { useMemo } from "react";
import useGetDashboardTodos from "./useGetDashboardTodos";

export type MailKeptTodos = {
    keptTodos: TodoItem[];
    isLoading: boolean;
};

const NO_KEPT_TODOS: TodoItem[] = [];

/**
 * Todos acceptés et non terminés d'un mail sans analyse (corbeille, archive) : sa copie n'a pas
 * d'aiDetails, ses todos ne vivent plus que dans le widget. `null` quand le mail porte sa propre
 * analyse (ou n'a pas d'identifiant) : ses todos viennent alors de l'analyse.
 * Mirror: apps/mobile/src/presentation/hooks/useMailKeptTodos.ts
 */
const useMailKeptTodos = (mail?: Email): MailKeptTodos | null => {
    const internetMessageId = mail?.internetMessageId;
    const isMailWithoutAnalysis =
        Boolean(internetMessageId) && !mail?.aiDetails;

    const dashboardTodos = useGetDashboardTodos();

    const keptTodos = useMemo(
        () =>
            dashboardTodos.data?.filter(
                (todo) =>
                    !todo.done && todo.internetMessageId === internetMessageId,
            ) ?? NO_KEPT_TODOS,
        [dashboardTodos.data, internetMessageId],
    );

    if (!isMailWithoutAnalysis) {
        return null;
    }

    return { keptTodos, isLoading: dashboardTodos.isLoading };
};

export default useMailKeptTodos;
